import { Injectable } from '@angular/core';
import { SalesWstoExportQuery, SalesWstoExportQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalesWstoExportQuery)
@Wrapper(SalesWstoExportQueryHandlerBase)
export class SalesWstoExportQueryHandler {
    public constructor(
        http: Http
    ) { }
}
